import { createSelector } from "reselect";

const catalogoReducerDataSelector = (state) => state.catalogoReducer.getIn(["data"]).toJS();
export const catalogoDataSelector = createSelector(catalogoReducerDataSelector, (dataField) => {
  // armo la lista de catalogos
  let myCatalogos = undefined;
  if (dataField.catalogos !== undefined) {
    myCatalogos = [];

    for (var i = 0; i < dataField.catalogos.length; i++) {
      let item = dataField.catalogos[i];

      // busco la imagen del catálogo

      if (dataField.imagenesCatalogo !== undefined) {
        let imagenCatalogo = dataField.imagenesCatalogo.find((ic) => {
          if (ic.idCatalogo === item.idCatalogo) return ic;
        });
        item.imagenCatalogo = imagenCatalogo !== undefined ? imagenCatalogo.imagen : undefined;
      }

      myCatalogos.push(item);
    }
  }

  // armo el catálogo completo
  let myCatalogoCompleto = undefined;
  if (dataField.catalogoCompleto !== undefined) {
    myCatalogoCompleto = dataField.catalogoCompleto;

    // itero los rubros
    for (var j = 0; j < myCatalogoCompleto.listaRubros.length; j++) {
      let rubro = myCatalogoCompleto.listaRubros[j];

      // itero los subrubros
      for (var k = 0; k < rubro.listaSubRubros.length; k++) {
        let subrubro = rubro.listaSubRubros[k];

        // itero los artículos
        for (var n = 0; n < subrubro.listaArticulos.length; n++) {
          let articulo = subrubro.listaArticulos[n];

          // busco las imágenes del artículo dentro del arreglo de imágenes de articulos
          if (dataField.imagenesArticulo !== undefined) {
            let imagenesArticulo = dataField.imagenesArticulo.find((ia) => {
              if (ia.idArticulo == articulo.idArticulo) return ia;
            });
            articulo.listaImagenesArticulos =
              imagenesArticulo != undefined ? imagenesArticulo.imagenes : undefined;
          }
        }
      }
    }
  }

  return {
    catalogos: myCatalogos,
    idCatalogo: dataField.idCatalogo,
    catalogoCompleto: myCatalogoCompleto,
    imagenesActualizadas: dataField.imagenesActualizadas,
    catalogoAuxiliar: dataField.catalogoAuxiliar,
  };
});

export const publicadosSelector = createSelector(catalogoReducerDataSelector, (dataField) => {
  return {
    data: dataField.publicados,
    selected: dataField.selectedCatalogo,
  };
});
